<template>
    <v-row>
        <v-col cols="12" class="text-body-2 d-flex justify-space-between align-center">
            Sets
        </v-col>
      <v-col>
        <v-data-table
            :headers="headers"
            :items="items"
            disable-pagination
            class="elevation-1"
            hide-default-header
            hide-default-footer
            @click:row="handleClick"
            dense
        >
          <template v-slot:item.stock="{item}">
            <v-row>
              <v-col>Stock: {{ item.on_hand }}</v-col>
              <v-col>Incoming: {{ item.incoming }} </v-col>
              <v-col>Pending: {{ item.pending }} </v-col>
            </v-row>
          </template>

        </v-data-table>
      </v-col>
    </v-row>
</template>

<script>
export default {
  data: () => {
    return {
      headers: [
        {
          text: 'ID',
          value: 'name',
        },
        {
          text: 'particleList',
          value: 'particleList',
        },
        {
          text: 'classification',
          value: 'classification',
        },
      ]
    }
  },
    props:{
        items:{
            type: Array,
            required:true
        },
        type: {
            type: String,
            default: () => 'all'
        }
    },
    methods:{
        open(id){
            this.$router.push('/sets/view/'+id);
            this.$emit('close')
        },
      handleClick(item) {
        this.open(item.id)
      },
    }
}
</script>